import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { SettlementAccount } from '@repo/sdk'
import { formatKstDateTime } from '../../utils/formatKstDateTime'

interface SettlementAccountInfoCardProps {
  account: SettlementAccount
}

export function SettlementAccountInfoCard({ account }: SettlementAccountInfoCardProps) {
  const { t } = useTranslation()

  return (
    <Card title={t('pages.settlements.sections.currentAccount')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.settlements.fields.bank')}>
          {t(`common.banks.${account.bankName}`)}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.settlements.fields.accountNumber')}>
          {account.accountNumber}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.settlements.fields.registeredAt')}>
          {formatKstDateTime(account.registeredAt, 'YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.settlements.fields.updatedAt')}>
          {formatKstDateTime(account.updatedAt, 'YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
